import React from 'react';
import PropTypes from 'prop-types';
import { getMissingMessage } from '../../shared/utils/UtilsHelper';

class CardDescription extends React.Component {
    constructor(props) {
        super(props);
        const { height } = props;

        this.state = {
            open     : false,
            showMore : null,
        };

        this.collapsedStyle = { maxHeight: height };

        this.open = this.open.bind(this);
        this.setShowMore = this.setShowMore.bind(this);
        this.childRef = React.createRef();
        this.parentRef = React.createRef();
    }

    componentDidMount() {
        const { content } = this.props;
        if (content) {
            this.setShowMore();
        }
    }

    componentDidUpdate(prevProps) {
        const { content: prevContent } = prevProps;
        const { content } = this.props;
        if (content && content !== prevContent) {
            this.setShowMore();
        }
    }

    setShowMore() {
        const clientHeightChildren = this.childRef.current ? this.childRef.current.clientHeight : 0;
        const clientHeightParent = this.parentRef.current ? this.parentRef.current.clientHeight : 0;

        if (clientHeightChildren === 0 && clientHeightParent === 0) {
            return;
        }
        this.setState({ showMore: clientHeightParent < clientHeightChildren });
    }

    open() {
        this.setState(prevState => ({ open: !prevState.open }));
    }

    render() {
        const { showMore, open } = this.state;
        const { content, className } = this.props;
        const hidden = (!showMore || open) ? '' : 'kbe-card-description-hidden';
        const expandedStyle = { maxHeight: '100vh' };

        if (!content) {
            return null;
        }

        // i18nLabel[bf.showLess]
        // i18nLabel[bf.showMore]

        return (
            <div className={`kbe-card-description-wrapper ${className} fading-text-wrapper-custom-class`}>
                <div
                    ref={this.parentRef}
                    style={(showMore === false || open) ? expandedStyle : this.collapsedStyle}
                    className={`kbe-card-description ${hidden}`}
                >
                    <div ref={this.childRef} dangerouslySetInnerHTML={{ __html: content }} />
                    <div className="kbe-card-description-shadow fading-text-custom-class" />
                </div>
                {
                    showMore ? <button
                        type="button"
                        className="kbe-card-description-toggle kbe-link-style"
                        onClick={() => {
                            this.open();
                        }}
                    >
                        {
                            open ? getMissingMessage('bf.showLess')
                                : getMissingMessage('bf.showMore')
                        }
                    </button> : null
                }
            </div>
        );
    }
}

CardDescription.defaultProps = {
    height            : '4rem',
    className         : '',
    content           : null,
};

CardDescription.propTypes = {
    height            : PropTypes.string,
    content           : PropTypes.oneOfType([ PropTypes.string, PropTypes.node ]),
    className         : PropTypes.string,
};

export default CardDescription;
